import { render, staticRenderFns } from "./ActivoFijoFormComponent.vue?vue&type=template&id=5413087c&scoped=true&"
import script from "./ActivoFijoFormComponent.vue?vue&type=script&lang=js&"
export * from "./ActivoFijoFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./ActivoFijoFormComponent.vue?vue&type=style&index=0&id=5413087c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5413087c",
  null
  
)

export default component.exports